//axio api
import api from "@/lib/Api";

//connectConfig
import connectConfig from "@/config/connectConfig";

//create CKEditor plugIn
export default function CKimageUploader(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return uploadAdapter(loader);
  };
}

//create a custom uploader
function uploadAdapter(loader) {
  return {
    upload: () => {
      return new Promise(async (resolve, reject) => {
        const queryRoute = "/notice/createOrUpdateNoticePhoto";
        const file = await loader.file;

        const reqBody = {
          files: file,
          type: "website",
        };
        const headers = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        try {
          const response = await api.axios.post(queryRoute, reqBody, headers);

          resolve({
            default: `${connectConfig.s3}/${response.data.data.fileName}`,
          });
        } catch (error) {
          reject(`error: ${error}`);
        }
      });
    },
    abort: () => {},
  };
}
